// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {store} from './vuex/store'
import moment from 'moment'
import Croppa from 'vue-croppa';

// import Slider from '@jeremyhamm/vue-slider'

// Vue.use(Slider)
Vue.use(Croppa);
Vue.config.productionTip = false
Vue.use(require('vue-moment'));

Vue.filter('formatDate', function (value) {
  if (!value) return ''
  return moment(value.toString()).format('MM/DD/YYYY hh:mm')
})
export const bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js